import React from 'react';
import ReleaseOfRecords from '../../resources/forms/Authorization-for-Release-of-Medical-Information.pdf';

const NewPatients = () => {
    return (
        <section className="new-patients">
            <div className="content">
                <h1>New Patients</h1>
                <p className="fuller">
                    At Firefly Pediatrics we are committed to providing the highest level of care for our patients.
                    Routine vaccination is critical to the health and safety of our children and our community.
                    Therefore, we are not accepting patients who are refusing all routine childhood vaccinations.
                    <br /><br />If you have genuine questions about vaccine safety, we are more than happy to have
                    conversations and answer questions. Many parents go through a time where they have
                    concerns about vaccinations – it’s hard not to with as much misinformation and
                    antivaccine pressure as is present on the internet and social media. We are not offended
                    and do not judge you for having questions. We love to have these conversations
                    with families and encourage you to be fully informed in the medical decision making for your
                    child.
                    <br /><br />If you would like to join our practice, please fill out the <a className="glow" href={ReleaseOfRecords}>Release of Medical Records</a>
                </p>
            </div>
        </section>
    )
}

export default NewPatients;


// WEBPACK FOOTER //
// ./src/components/new-patients/new-patients.js